"use strict";
/*
 * HSOverlay
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var constants_1 = require("../../constants");
var base_plugin_1 = __importDefault(require("../base-plugin"));
var HSOverlay = /** @class */ (function (_super) {
    __extends(HSOverlay, _super);
    function HSOverlay(el, options, events) {
        var _a, _b, _c, _d, _e;
        var _this = _super.call(this, el, options, events) || this;
        var data = el.getAttribute('data-hs-overlay-options');
        var dataOptions = data ? JSON.parse(data) : {};
        var concatOptions = __assign(__assign({}, dataOptions), options);
        _this.hiddenClass = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.hiddenClass) || 'hidden';
        _this.emulateScrollbarSpace = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.emulateScrollbarSpace) || false;
        _this.isClosePrev = (_a = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.isClosePrev) !== null && _a !== void 0 ? _a : true;
        _this.backdropClasses =
            (_b = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.backdropClasses) !== null && _b !== void 0 ? _b : 'hs-overlay-backdrop transition duration fixed inset-0 bg-gray-900 bg-opacity-50 dark:bg-opacity-80 dark:bg-neutral-900';
        _this.backdropExtraClasses = (_c = concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.backdropExtraClasses) !== null && _c !== void 0 ? _c : '';
        _this.moveOverlayToBody = (concatOptions === null || concatOptions === void 0 ? void 0 : concatOptions.moveOverlayToBody) || null;
        _this.openNextOverlay = false;
        _this.autoHide = null;
        _this.overlayId = _this.el.getAttribute('data-hs-overlay');
        _this.overlay = document.querySelector(_this.overlayId);
        _this.initContainer = ((_d = _this.overlay) === null || _d === void 0 ? void 0 : _d.parentElement) || null;
        if (_this.overlay) {
            _this.isCloseWhenClickInside = (0, utils_1.stringToBoolean)((0, utils_1.getClassProperty)(_this.overlay, '--close-when-click-inside', 'false') ||
                'false');
            _this.isTabAccessibilityLimited = (0, utils_1.stringToBoolean)((0, utils_1.getClassProperty)(_this.overlay, '--tab-accessibility-limited', 'true') ||
                'true');
            _this.isLayoutAffect = (0, utils_1.stringToBoolean)((0, utils_1.getClassProperty)(_this.overlay, '--is-layout-affect', 'false') ||
                'false');
            _this.hasAutofocus = (0, utils_1.stringToBoolean)((0, utils_1.getClassProperty)(_this.overlay, '--has-autofocus', 'true') || 'true');
            _this.hasAbilityToCloseOnBackdropClick = (0, utils_1.stringToBoolean)(_this.overlay.getAttribute('data-hs-overlay-keyboard') || 'true');
            var autoCloseBreakpoint = (0, utils_1.getClassProperty)(_this.overlay, '--auto-close');
            _this.autoClose =
                !isNaN(+autoCloseBreakpoint) && isFinite(+autoCloseBreakpoint)
                    ? +autoCloseBreakpoint
                    : constants_1.BREAKPOINTS[autoCloseBreakpoint] || null;
            var openedBreakpoint = (0, utils_1.getClassProperty)(_this.overlay, '--opened');
            _this.openedBreakpoint =
                (!isNaN(+openedBreakpoint) && isFinite(+openedBreakpoint)
                    ? +openedBreakpoint
                    : constants_1.BREAKPOINTS[openedBreakpoint]) || null;
        }
        _this.animationTarget =
            ((_e = _this === null || _this === void 0 ? void 0 : _this.overlay) === null || _e === void 0 ? void 0 : _e.querySelector('.hs-overlay-animation-target')) ||
                _this.overlay;
        if (_this.overlay)
            _this.init();
        return _this;
    }
    HSOverlay.prototype.init = function () {
        var _this = this;
        var _a;
        this.createCollection(window.$hsOverlayCollection, this);
        if (this.isLayoutAffect && this.openedBreakpoint) {
            var instance = HSOverlay.getInstance(this.el, true);
            HSOverlay.setOpened(this.openedBreakpoint, instance);
        }
        if ((_a = this === null || this === void 0 ? void 0 : this.el) === null || _a === void 0 ? void 0 : _a.ariaExpanded) {
            if (this.overlay.classList.contains('opened'))
                this.el.ariaExpanded = 'true';
            else
                this.el.ariaExpanded = 'false';
        }
        this.el.addEventListener('click', function () {
            if (_this.overlay.classList.contains('opened'))
                _this.close();
            else
                _this.open();
        });
        this.overlay.addEventListener('click', function (evt) {
            if (evt.target.id &&
                "#".concat(evt.target.id) === _this.overlayId &&
                _this.isCloseWhenClickInside &&
                _this.hasAbilityToCloseOnBackdropClick) {
                _this.close();
            }
        });
    };
    HSOverlay.prototype.hideAuto = function () {
        var _this = this;
        var time = parseInt((0, utils_1.getClassProperty)(this.overlay, '--auto-hide', '0'));
        if (time) {
            this.autoHide = setTimeout(function () {
                _this.close();
            }, time);
        }
    };
    HSOverlay.prototype.checkTimer = function () {
        if (this.autoHide) {
            clearTimeout(this.autoHide);
            this.autoHide = null;
        }
    };
    HSOverlay.prototype.buildBackdrop = function () {
        var _this = this;
        var overlayClasses = this.overlay.classList.value.split(' ');
        var overlayZIndex = parseInt(window.getComputedStyle(this.overlay).getPropertyValue('z-index'));
        var backdropId = this.overlay.getAttribute('data-hs-overlay-backdrop-container') || false;
        var backdrop = document.createElement('div');
        var backdropClasses = "".concat(this.backdropClasses, " ").concat(this.backdropExtraClasses);
        var closeOnBackdrop = (0, utils_1.getClassProperty)(this.overlay, '--overlay-backdrop', 'true') !== 'static';
        var disableBackdrop = (0, utils_1.getClassProperty)(this.overlay, '--overlay-backdrop', 'true') === 'false';
        backdrop.id = "".concat(this.overlay.id, "-backdrop");
        if ('style' in backdrop)
            backdrop.style.zIndex = "".concat(overlayZIndex - 1);
        for (var _i = 0, overlayClasses_1 = overlayClasses; _i < overlayClasses_1.length; _i++) {
            var value = overlayClasses_1[_i];
            if (value.startsWith('hs-overlay-backdrop-open:') ||
                value.includes(':hs-overlay-backdrop-open:')) {
                backdropClasses += " ".concat(value);
            }
        }
        if (disableBackdrop)
            return;
        if (backdropId) {
            backdrop = document.querySelector(backdropId).cloneNode(true);
            backdrop.classList.remove('hidden');
            backdropClasses = "".concat(backdrop.classList.toString());
            backdrop.classList.value = '';
        }
        if (closeOnBackdrop) {
            backdrop.addEventListener('click', function () { return _this.close(); }, true);
        }
        backdrop.setAttribute('data-hs-overlay-backdrop-template', '');
        document.body.appendChild(backdrop);
        setTimeout(function () {
            backdrop.classList.value = backdropClasses;
        });
    };
    HSOverlay.prototype.destroyBackdrop = function () {
        var backdrop = document.querySelector("#".concat(this.overlay.id, "-backdrop"));
        if (!backdrop)
            return;
        if (this.openNextOverlay) {
            backdrop.style.transitionDuration = "".concat(parseFloat(window
                .getComputedStyle(backdrop)
                .transitionDuration.replace(/[^\d.-]/g, '')) * 1.8, "s");
        }
        backdrop.classList.add('opacity-0');
        (0, utils_1.afterTransition)(backdrop, function () {
            backdrop.remove();
        });
    };
    HSOverlay.prototype.focusElement = function () {
        var input = this.overlay.querySelector('[autofocus]');
        if (!input)
            return false;
        else
            input.focus();
    };
    HSOverlay.prototype.getScrollbarSize = function () {
        var div = document.createElement('div');
        div.style.overflow = 'scroll';
        div.style.width = '100px';
        div.style.height = '100px';
        document.body.appendChild(div);
        var scrollbarSize = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
        return scrollbarSize;
    };
    // Public methods
    HSOverlay.prototype.open = function () {
        var _this = this;
        if (!this.overlay)
            return false;
        var openedOverlays = document.querySelectorAll('.hs-overlay.open');
        var currentlyOpened = window.$hsOverlayCollection.find(function (el) {
            return Array.from(openedOverlays).includes(el.element.overlay) &&
                !el.element.isLayoutAffect;
        });
        var toggles = document.querySelectorAll("[data-hs-overlay=\"#".concat(this.overlay.id, "\"]"));
        var disabledScroll = (0, utils_1.getClassProperty)(this.overlay, '--body-scroll', 'false') !== 'true';
        if (this.isClosePrev && currentlyOpened) {
            this.openNextOverlay = true;
            return currentlyOpened.element.close().then(function () {
                _this.open();
                _this.openNextOverlay = false;
            });
        }
        if (disabledScroll) {
            document.body.style.overflow = 'hidden';
            if (this.emulateScrollbarSpace)
                document.body.style.paddingRight = "".concat(this.getScrollbarSize(), "px");
        }
        this.buildBackdrop();
        this.checkTimer();
        this.hideAuto();
        toggles.forEach(function (toggle) {
            if (toggle.ariaExpanded)
                toggle.ariaExpanded = 'true';
        });
        this.overlay.classList.remove(this.hiddenClass);
        this.overlay.setAttribute('aria-overlay', 'true');
        this.overlay.setAttribute('tabindex', '-1');
        setTimeout(function () {
            if (_this.overlay.classList.contains('opened'))
                return false;
            _this.overlay.classList.add('open', 'opened');
            if (_this.isLayoutAffect)
                document.body.classList.add('hs-overlay-body-open');
            _this.fireEvent('open', _this.el);
            (0, utils_1.dispatch)('open.hs.overlay', _this.el, _this.el);
            if (_this.hasAutofocus)
                _this.focusElement();
        }, 50);
    };
    HSOverlay.prototype.close = function (forceClose) {
        var _this = this;
        if (forceClose === void 0) { forceClose = false; }
        if (this.isLayoutAffect)
            document.body.classList.remove('hs-overlay-body-open');
        var closeFn = function (cb) {
            if (_this.overlay.classList.contains('open'))
                return false;
            var toggles = document.querySelectorAll("[data-hs-overlay=\"#".concat(_this.overlay.id, "\"]"));
            toggles.forEach(function (toggle) {
                if (toggle.ariaExpanded)
                    toggle.ariaExpanded = 'false';
            });
            _this.overlay.classList.add(_this.hiddenClass);
            _this.destroyBackdrop();
            _this.fireEvent('close', _this.el);
            (0, utils_1.dispatch)('close.hs.overlay', _this.el, _this.el);
            if (!document.querySelector('.hs-overlay.opened')) {
                document.body.style.overflow = '';
                if (_this.emulateScrollbarSpace)
                    document.body.style.paddingRight = '';
            }
            cb(_this.overlay);
        };
        return new Promise(function (resolve) {
            if (!_this.overlay)
                return false;
            _this.overlay.classList.remove('open', 'opened');
            _this.overlay.removeAttribute('aria-overlay');
            _this.overlay.removeAttribute('tabindex');
            if (forceClose)
                closeFn(resolve);
            else
                (0, utils_1.afterTransition)(_this.animationTarget, function () { return closeFn(resolve); });
        });
    };
    // Static methods
    HSOverlay.getInstance = function (target, isInstance) {
        var elInCollection = window.$hsOverlayCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string'
                    ? document.querySelector(target)
                    : target) ||
                el.element.overlay ===
                    (typeof target === 'string'
                        ? document.querySelector(target)
                        : target);
        });
        return elInCollection
            ? isInstance
                ? elInCollection
                : elInCollection.element.el
            : null;
    };
    HSOverlay.autoInit = function () {
        if (!window.$hsOverlayCollection)
            window.$hsOverlayCollection = [];
        document
            .querySelectorAll('[data-hs-overlay]:not(.--prevent-on-load-init)')
            .forEach(function (el) {
            if (!window.$hsOverlayCollection.find(function (elC) { var _a; return ((_a = elC === null || elC === void 0 ? void 0 : elC.element) === null || _a === void 0 ? void 0 : _a.el) === el; }))
                new HSOverlay(el);
        });
        if (window.$hsOverlayCollection) {
            document.addEventListener('keydown', function (evt) {
                return HSOverlay.accessibility(evt);
            });
        }
    };
    HSOverlay.open = function (target) {
        var elInCollection = window.$hsOverlayCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string'
                    ? document.querySelector(target)
                    : target) ||
                el.element.overlay ===
                    (typeof target === 'string'
                        ? document.querySelector(target)
                        : target);
        });
        if (elInCollection &&
            elInCollection.element.overlay.classList.contains(elInCollection.element.hiddenClass))
            elInCollection.element.open();
    };
    HSOverlay.close = function (target) {
        var elInCollection = window.$hsOverlayCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string'
                    ? document.querySelector(target)
                    : target) ||
                el.element.overlay ===
                    (typeof target === 'string'
                        ? document.querySelector(target)
                        : target);
        });
        if (elInCollection &&
            !elInCollection.element.overlay.classList.contains(elInCollection.element.hiddenClass))
            elInCollection.element.close();
    };
    HSOverlay.setOpened = function (breakpoint, el) {
        if (document.body.clientWidth >= breakpoint) {
            document.body.classList.add('hs-overlay-body-open');
            el.element.overlay.classList.add('opened');
        }
        else
            el.element.close(true);
    };
    // Accessibility methods
    HSOverlay.accessibility = function (evt) {
        var _a, _b;
        var targets = window.$hsOverlayCollection.filter(function (el) {
            return el.element.overlay.classList.contains('open');
        });
        var target = targets[targets.length - 1];
        var focusableElements = (_b = (_a = target === null || target === void 0 ? void 0 : target.element) === null || _a === void 0 ? void 0 : _a.overlay) === null || _b === void 0 ? void 0 : _b.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        var notHiddenFocusableElements = [];
        if (focusableElements === null || focusableElements === void 0 ? void 0 : focusableElements.length)
            focusableElements.forEach(function (el) {
                if (!(0, utils_1.isParentOrElementHidden)(el))
                    notHiddenFocusableElements.push(el);
            });
        var basicCheck = target && !evt.metaKey;
        if (basicCheck &&
            !target.element.isTabAccessibilityLimited &&
            evt.code === 'Tab')
            return false;
        if (basicCheck && notHiddenFocusableElements.length && evt.code === 'Tab') {
            evt.preventDefault();
            this.onTab(target, notHiddenFocusableElements);
        }
        if (basicCheck && evt.code === 'Escape') {
            evt.preventDefault();
            this.onEscape(target);
        }
    };
    HSOverlay.onEscape = function (target) {
        if (target && target.element.hasAbilityToCloseOnBackdropClick)
            target.element.close();
    };
    HSOverlay.onTab = function (target, focusableElements) {
        if (!focusableElements.length)
            return false;
        var focused = target.element.overlay.querySelector(':focus');
        var focusedIndex = Array.from(focusableElements).indexOf(focused);
        if (focusedIndex > -1) {
            var nextIndex = (focusedIndex + 1) % focusableElements.length;
            focusableElements[nextIndex].focus();
        }
        else {
            focusableElements[0].focus();
        }
    };
    // Backward compatibility
    HSOverlay.on = function (evt, target, cb) {
        var elInCollection = window.$hsOverlayCollection.find(function (el) {
            return el.element.el ===
                (typeof target === 'string'
                    ? document.querySelector(target)
                    : target) ||
                el.element.overlay ===
                    (typeof target === 'string'
                        ? document.querySelector(target)
                        : target);
        });
        if (elInCollection)
            elInCollection.element.events[evt] = cb;
    };
    return HSOverlay;
}(base_plugin_1.default));
var autoCloseResizeFn = function () {
    if (!window.$hsOverlayCollection.length ||
        !window.$hsOverlayCollection.find(function (el) { return el.element.autoClose; }))
        return false;
    var overlays = window.$hsOverlayCollection.filter(function (el) { return el.element.autoClose; });
    overlays.forEach(function (overlay) {
        if (document.body.clientWidth >= overlay.element.autoClose)
            overlay.element.close(true);
    });
};
var moveOverlayToBodyResizeFn = function () {
    if (!window.$hsOverlayCollection.length ||
        !window.$hsOverlayCollection.find(function (el) { return el.element.moveOverlayToBody; }))
        return false;
    var overlays = window.$hsOverlayCollection.filter(function (el) { return el.element.moveOverlayToBody; });
    overlays.forEach(function (overlay) {
        var resolution = overlay.element.moveOverlayToBody;
        var initPlace = overlay.element.initContainer;
        var newPlace = document.querySelector('body');
        var target = overlay.element.overlay;
        if (!initPlace && target)
            return false;
        if (document.body.clientWidth <= resolution &&
            !(0, utils_1.isDirectChild)(newPlace, target))
            newPlace.appendChild(target);
        else if (document.body.clientWidth > resolution &&
            !initPlace.contains(target))
            initPlace.appendChild(target);
    });
};
var setOpenedResizeFn = function () {
    if (!window.$hsOverlayCollection.length ||
        !window.$hsOverlayCollection.find(function (el) { return el.element.autoClose; }))
        return false;
    var overlays = window.$hsOverlayCollection.filter(function (el) { return el.element.autoClose; });
    overlays.forEach(function (overlay) {
        if (document.body.clientWidth >= overlay.element.autoClose)
            overlay.element.close(true);
    });
};
var setBackdropZIndexResizeFn = function () {
    if (!window.$hsOverlayCollection.length ||
        !window.$hsOverlayCollection.find(function (el) {
            return el.element.overlay.classList.contains('opened');
        }))
        return false;
    var overlays = window.$hsOverlayCollection.filter(function (el) {
        return el.element.overlay.classList.contains('opened');
    });
    overlays.forEach(function (overlay) {
        var overlayZIndex = parseInt(window
            .getComputedStyle(overlay.element.overlay)
            .getPropertyValue('z-index'));
        var backdrop = document.querySelector("#".concat(overlay.element.overlay.id, "-backdrop"));
        var backdropZIndex = parseInt(window.getComputedStyle(backdrop).getPropertyValue('z-index'));
        if (overlayZIndex === backdropZIndex + 1)
            return false;
        if ('style' in backdrop)
            backdrop.style.zIndex = "".concat(overlayZIndex - 1);
        document.body.classList.add('hs-overlay-body-open');
    });
};
window.addEventListener('load', function () {
    HSOverlay.autoInit();
    moveOverlayToBodyResizeFn();
    // Uncomment for debug
    // console.log('Overlay collection:', window.$hsOverlayCollection);
});
window.addEventListener('resize', function () {
    autoCloseResizeFn();
    moveOverlayToBodyResizeFn();
    setOpenedResizeFn();
    setBackdropZIndexResizeFn();
});
if (typeof window !== 'undefined') {
    window.HSOverlay = HSOverlay;
}
exports.default = HSOverlay;
